import { bool, func } from 'prop-types';
import { useEffect } from 'react';

export default function GoogleMapsScript({ mounted, setMounted }) {
  const src = `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY}&libraries=places`;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const googleScript = document.getElementById('mounted_google');

      if (!googleScript && !mounted) {
        const script = document.createElement('script');
        script.id = 'mounted_google';
        script.type = 'text/javascript';

        script.src = src;
        script.async = true;
        script.defer = true;

        script.onload = () => setMounted(true);
        document.body.appendChild(script);
      }
    }

    return () => {
      if (typeof window !== 'undefined') {
        const googleScript = document.getElementById('mounted_google');
        if (googleScript) {
          document.body.removeChild(googleScript);
        }
      }
    };
  }, [mounted]);

  return null;
}

GoogleMapsScript.propTypes = {
  mounted: bool.isRequired,
  setMounted: func.isRequired,
};
